export type TCommunicationTaskStepId = 1 | 2 | 3;
export type TCommunicationTaskStepKey = "matching" | "changes" | "questions";
export type TCommunicationTaskStepStatus = "done" | "attention" | "optional";
export type TCommunicationTaskStepIconKey = "check" | "attention" | "note";

export type TCommunicationTaskStep = {
  id: TCommunicationTaskStepId;
  key: TCommunicationTaskStepKey;
  titleKey: string;
  descriptionKey: string;
  status: TCommunicationTaskStepStatus;
  icon: TCommunicationTaskStepIconKey;
  badgeTextKey: string;
  count: number;
  isClickable: boolean;
  blocksNext: boolean;
  blocksApprove: boolean;
};

type TBuildCommunicationTaskStepsParams = {
  isMatchComplete: boolean;
  reviewChangesCount: number;
  openQuestionsCount: number;
};

export const buildCommunicationTaskSteps = ({
  isMatchComplete,
  reviewChangesCount,
  openQuestionsCount,
}: TBuildCommunicationTaskStepsParams): TCommunicationTaskStep[] => [
  {
    id: 1,
    key: "matching",
    titleKey: "COMMUNICATION.Step_Matching_Title",
    descriptionKey: "COMMUNICATION.Step_Matching_Help",
    status: isMatchComplete ? "done" : "attention",
    icon: isMatchComplete ? "check" : "attention",
    badgeTextKey:
      isMatchComplete
        ? "COMMUNICATION.StepStatus_Ready"
        : "COMMUNICATION.StepStatus_NeedsMatch",
    count: 0,
    isClickable: true,
    blocksNext: !isMatchComplete,
    blocksApprove: !isMatchComplete,
  },
  {
    id: 2,
    key: "changes",
    titleKey: "COMMUNICATION.Step_Changes_Title",
    descriptionKey: "COMMUNICATION.Step_Changes_Help",
    status: reviewChangesCount > 0 ? "attention" : "done",
    icon: reviewChangesCount > 0 ? "attention" : "check",
    badgeTextKey:
      reviewChangesCount > 0
        ? "COMMUNICATION.StepStatus_ReviewCount"
        : "COMMUNICATION.StepStatus_Reviewed",
    count: reviewChangesCount,
    isClickable: true,
    blocksNext: false,
    blocksApprove: false,
  },
  {
    id: 3,
    key: "questions",
    titleKey: "COMMUNICATION.Step_Questions_Title",
    descriptionKey: "COMMUNICATION.Step_Questions_Help",
    status: openQuestionsCount > 0 ? "optional" : "done",
    icon: openQuestionsCount > 0 ? "note" : "check",
    badgeTextKey:
      openQuestionsCount > 0
        ? "COMMUNICATION.StepStatus_OpenCount"
        : "COMMUNICATION.StepStatus_NoQuestions",
    count: openQuestionsCount,
    isClickable: true,
    blocksNext: false,
    blocksApprove: false,
  },
];
